<template>
	<div class="auth--splash" :style="{backgroundImage: bg}">
		<div class="row g-0 vh-100 align-items-end" :style="{backgroundColor: overlay}">
			<div v-if="!loading && art" class="article p-4 p-xxl-5">
				<h6 class="subtitle">From our blog</h6>
				<h2 class="title">{{art.title}}</h2>
				<div class="description" v-html="art.description"></div>
				<div class="link"><a :href="art.link" target="_blank" class="btn bt-lg btn-outline-light">Read more</a></div>
			</div>
			<div v-if="!loading && !art" class="p-4 mx-auto">
				<h1 v-if="title" class="m-0 text-uppercase">{{title}}</h1>
				<h2 v-if="subtitle" class="m-0">{{subtitle}}</h2>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
    	props: {
    		title: {
    			type: String,
    			default: 'Data Management'
    		},
    		subtitle: {
    			type: String,
    			default: 'Just got a whole lot better!'
    		},
    		opacity: {
    			type: String,
    			default: '.20'
    		}
    	},
    	data() {
    		return { article: null, loading: true }
    	},
    	computed: {
    		bg() {
    			let l = Math.floor(Math.random() * 5) + 1  
    			return ' url(\'/img/background/bg.auth.' + l + '.jpg\')'
    		},
    		overlay() {
    			return 'rgba(0, 0, 0,' + this.opacity + ')'
    		},
    		art() {
    			return this.article && this.article.title && this.article.description ? this.article : null
    		}
    	},
    	created() {
    		axios.get('/highlight').then(response => { 
    			this.article = response.data 
    			this.loading = false
    		}).catch(error => { this.loading = false })
    	}
    }
</script>
